import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const StyledButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 2rem;

  ${(props) => props.theme.media.tablet_landscape_up`
    flex-direction: row;

    > * {
      margin-right: 2rem;
    }
  `}
`
function ButtonGroup({ children, ...props }) {
  return <StyledButtonGroup {...props}>{children}</StyledButtonGroup>
}

export default ButtonGroup

ButtonGroup.defaultProps = {}
ButtonGroup.propTypes = {
  children: PropTypes.node.isRequired,
}
